import script from "./Header1Component.vue?vue&type=script&setup=true&lang=js"
export * from "./Header1Component.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__